import { useEffect, useState } from "react";

import { Time } from "../../../../shared/types/time";
import { padLeft } from "../../utils/pad-left";

export function TotalTimer({
  times,
  flashColonIfActive = true,
}: {
  times: Time[];
  flashColonIfActive?: boolean;
}) {
  const [value, setValue] = useState<string | undefined>(undefined);

  function isAnyActive(times: Time[]) {
    return times.some((t) => !t.to);
  }

  useEffect(() => {
    setValue(totalTime(times, true));
    if (isAnyActive(times)) {
      let showColon = false;
      const interval = setInterval(() => {
        setValue(totalTime(times, showColon || !flashColonIfActive));
        showColon = !showColon;
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [times, flashColonIfActive]);

  return <>{value}</>;
}

function totalTime(times: Time[], showColon: boolean = true): string {
  const totalTime = times.reduce((acc, t) => {
    return acc + diffBetweenDates(t.from, t.to ?? new Date());
  }, 0);

  const totalHours = Math.floor(totalTime / 3600000);
  const totalMinutes = Math.floor((totalTime % 3600000) / 60000);

  return `${totalHours}${showColon ? ":" : " "}${padLeft(totalMinutes, 2)}`;
}

export function diffBetweenDates(from: Date, to: Date): number {
  return to.getTime() - from.getTime();
}
